import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate } from '../../utils/helpers';

const PostCard = ({ post }) => {
    return (
        <div className="bg-white rounded-lg shadow-lg overflow-hidden transition-transform duration-300 hover:transform hover:scale-105">
            <div className="relative h-48">
                <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover"
                />
                <div className="absolute top-4 left-4">
                    <span className="bg-primary text-white px-3 py-1 rounded-full text-sm">
                        {post.category}
                    </span>
                </div>
            </div>
            <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-3">
                    <span>{post.author}</span>
                    <span className="mx-2">•</span>
                    <span>{formatDate(post.date)}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {post.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-2">
                    {post.description}
                </p>
                <Link
                    to={`/resources/post/${post.id}`}
                    className="inline-flex items-center text-primary hover:text-primary-dark font-medium"
                >
                    Read More
                    <svg
                        className="w-4 h-4 ml-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5l7 7-7 7"
                        />
                    </svg>
                </Link>
            </div>
        </div>
    );
};

export default PostCard; 